import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';
import replaceWithCDN from '../../util/replaceWithCDN';

const refactorHBCData = (data, settings, keyName) => {
  const key = keyName ? keyName : 'hbc';
  const newData = data.map((item, index) => {

    const img = item[`${key}ItemBannerImage`] ? refactorRespImg(item[`${key}ItemBannerImage`], [{
      size: 'default',
      key: 'image_size_840x350'
    },{
      size: 'md',
      key: 'image_size_1280x650',
    },{
      size: 'lg',
      key: 'image_size_1600x800',
    }]) : null;

    const id = `${key}_id_${index}`;

    const hbcItemCtasRep = item[`${key}ItemCtasRep`] ? get(item, `${key}ItemCtasRep`, []) : [];
  
    const ctas = hbcItemCtasRep.map(item => {
      return {
        href: get(item, `${key}ItemCtaLink.url`, null),
        title: get(item, `${key}ItemCtaLink.title`, null),
        color: get(item, `${key}ItemCtaColour`, null),
      }
    }).filter(item => item.href)

    return {
      id,
      // mainHeading: item.hbcItemHeading,
      // subHeading1: item.hbcItemSubHeading1,
      // subHeading2: item.hbcItemSubHeading2,
      mainHeading: item[`${key}ItemHeading`],
      subHeading1: item[`${key}ItemSubHeading1`],
      subHeading2: item[`${key}ItemSubHeading2`],

      headingImage: get(item, `${key}ItemGraphicLogo.sourceUrl`, null) ? {
        src: get(item, `${key}ItemGraphicLogo.sourceUrl`, null)
      } : null,
      bgVideoMobile: {
        src: replaceWithCDN(get(item, `${key}ItemVideoMobile.guid`, null)),
        mimeType: get(item, `${key}ItemVideoMobile.mimeType`, null)
      },
      bgVideoDesktop: {
        src: replaceWithCDN(get(item, `${key}ItemVideoDesktop.guid`, null)),
        mimeType: get(item, `${key}ItemVideoDesktop.mimeType`, null)
      },
      video: get(item, `${key}ItemVideoUrl.url`, null),
      bgImage: img,
      ctas,
      ...settings,
    }
  })

  return newData
}

export default refactorHBCData